export default __webpack_public_path__ + "static/media/rare5.d2a91ff1.gif";